/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoPraticaCloneSummaryDTO } from './tipo-pratica-clone-summary-dto';
import { TipoPraticaDTO } from './tipo-pratica-dto';


export interface TipoPraticaCloneResponseDTO { 
    tipo_pratica?: TipoPraticaDTO;
    clone_summary?: TipoPraticaCloneSummaryDTO;
}

